import { Injectable, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { columnsModel } from '../models/customer.model';
import { InteractionHistoryService } from './interaction-history.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from '../models/Constants';
import { AlightTableComponent } from '../components/common/alight-table/alight-table.component';


@Injectable({
  providedIn: 'root'
})
export class AgentInteractionService {

  @ViewChild(AlightTableComponent) alightTable;

  public dataSource = new BehaviorSubject<any>([]);
  selectedRow: any;


  /**Holds list view Table Data  */
  agentInteractionHistoryTableData = new MatTableDataSource([]);
  /**Holds Agent Filter Form Data  */
  agentFilterFormData: any;
  agentIHFilterDataMap: any = {};

  public viewColumns: columnsModel[] = [
    { field: 'channelIcon', header: 'Channel', width: 5 },
    { field: 'date', header: 'Date', width: 15 },
    { field: 'startTime', header: 'Start Time', width: 10 },
    { field: 'customer', header: 'Customer', width: 15 },
    { field: 'client', header: 'Client', width: 15 },
    { field: 'topic', header: 'Topic', width: 15 },

  ];

  constructor(public intHistService: InteractionHistoryService, private rootScope: RootScopeService) { }




  modifyAgentIHViewData(interHistData) {
    this.modifyAgentIHResponseData(interHistData);
    this.agentInteractionHistoryTableData = new MatTableDataSource(interHistData);
    this.agentIHFilterDataMap = new MatTableDataSource(interHistData);
  }

  /**
   * 
   * @param interHistData 
   */
  modifyAgentIHResponseData(interHistData) {
    let that = this;

    interHistData.sort(function (a, b) {
      return new Date(b.begin).valueOf() - new Date(a.begin).valueOf();
    });
    interHistData.map(function (each) {

      let istransferred: boolean = false;
      for (let i = 0; i < each?.buckets?.length; i++) {
        let obj = each?.buckets[i];
        if (obj?.keyName == Constants.IS_TRANSFERRED_FLAG && obj?.keyValue == true) {
          istransferred = true;
          break;
        }
      }
      each.channelIcon = that.intHistService.channelIconMap[each.channel];
      each.topic = that.checkFieldData(each.description);
      each.title = that.checkFieldData(each.channel);
      each.date = that.rootScope.getDate(each.begin);
      each.startTime = that.intHistService.getTime(each.begin);
      each.client = that.checkFieldData(each.clientName);
      each.customer = that.getSubjectName(each?.subject?.lastName, each?.subject?.firstName);
      each.multipleAccountData = that.getMultiAccountValue(each);



      if (each.channel == Constants.conversion.call && each.initiated) {  //CCR1-3264
        if (each.subject?.id == each.contact?.id) {
          each.channelForFilter = Constants.AGENT_FILTER.Call;
          each.customer = that.getContactName(each?.contact?.name);
          /*If call is Inbound call ,initiated field value = EXTERNAL and vice versa **/
          if (each.initiated == Constants.IH_INTERNAL_CALL) {
            each.title = 'Outbound Call';
          } else each.title = 'Inbound Call';
          
          /* istanbul ignore next */
          //CCR3-13170 if there are multiple accounts associated with the conversation then show Multiple Account Call in channel column instead of Inbound/Outbound Call and show transferred icon if the call is transferred.
           if (each.multipleAccountData && each.multipleAccountData.length > 0) {
            each.channelIcon = that.intHistService.channelIconMap.multipleAcnt;
            each.title = 'Multiple Account Call';
            each.channelForFilter = Constants.AGENT_FILTER.Call;
          }
          
          else if (istransferred) {
            each.channelIcon = that.intHistService.channelIconMap['TRANSFERRED_ICON'];
            each.title = 'Transferred Call';
            each.channelForFilter = Constants.AGENT_FILTER.Transfer;
          }
          else {
            each.channelIcon = each.channelIcon[each.initiated];
          }
        }
        else {  //CCR1-3264 Handling Additional Accounts on Main IH Card
          each.channelIcon = that.intHistService.channelIconMap.additionAcnt;
          each.title = Constants.ADDITIONAL_ACNT_TOOLTIP;
          each.customer = that.getSubjectName(each?.subject?.lastName, each?.subject?.firstName);
          each.topic = Constants.DO_NOT_DISCUSS;
          each.channelForFilter = Constants.ADDITIONAL_ACNT_TOOLTIP;
        }
      }



      if (each.channel == Constants.conversion.chat) {
        if (each.subject?.id == each.contact?.id) {
          each.customer = that.getContactName(each?.contact?.name);
          if (istransferred) {
            each.channelIcon = that.intHistService.channelIconMap['TRANSFERRED_ICON'];
            each.title = 'Transferred Chat';
            each.channelForFilter = Constants.AGENT_FILTER.Transfer;;
          }
          else {
            each.channelIcon = that.intHistService.channelIconMap.chat;
            each.title = 'Chat';
            each.channelForFilter = Constants.AGENT_FILTER.Chat;;
          }
        }
        else {
          each.channelIcon = that.intHistService.channelIconMap.additionAcnt;
          each.customer = that.getSubjectName(each?.subject?.lastName, each?.subject?.firstName);
          each.title = Constants.ADDITIONAL_ACNT_TOOLTIP;
          each.topic = Constants.DO_NOT_DISCUSS;
          each.channelForFilter = Constants.AGENT_FILTER.AdditionalAccount;
        }
      }

    });

  }

  /**
   * 
   * @param data 
   * @returns 
   */
  checkFieldData(data: any): any {
    return data ? data : Constants.DATA_NOT_ON_FILE;
  }

  /**
   * 
   * @param data 
   */
  getContactName(name: any) {
    // return this.checkFieldData(name) === Constants.DATA_NOT_ON_FILE ? Constants.DATA_NOT_ON_FILE : this.titleCasePipe.transform(name);
    return this.checkFieldData(name) === Constants.DATA_NOT_ON_FILE ? Constants.DATA_NOT_ON_FILE : this.getTitleCase(name);
  }

  /**
   * 
   * @param lastName 
   * @param firstName 
   * @returns 
   */
  getSubjectName(lastName: any, firstName: any) {
    let subLastName = this.getContactName(lastName);
    let subFirstName = this.getContactName(firstName);
    let finalName = '';

    if (subLastName !== Constants.DATA_NOT_ON_FILE) {
      finalName = subLastName;
    }
    if (subFirstName !== Constants.DATA_NOT_ON_FILE) {
      if (finalName) {
        finalName = finalName + "," + subFirstName;
      } else {
        finalName = subFirstName;
      }

    }

    return this.checkFieldData(finalName);
  }

  /**
   * 
   * @param self 
   * @param totalCount 
   */
  setAgentIHTableData(self, totalCount) {

    self.totalRecords = totalCount;

    setTimeout(() => {
      if (self.alightTable) {
        self.alightTable?.setGridSortAndPagination();
      }
    }, 10);

  }

  /**
   * Method to get name in title case
   * @param name 
   * @returns 
   */
  getTitleCase(name: string): string {
    return name.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  /**
   * CCR3-13170 Method to get multiple account value from buckets
   * @param each 
   * @returns 
   */
  getMultiAccountValue(each: any): any {
    let obj = each?.buckets?.find((bucket: any) => {
      return bucket?.keyName == Constants.MULTI_ACCOUNT_RECORDS;
    });

    if (obj) {
      return obj?.keyValue;
    } else {
      return '';
    }
  }


}


